var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-autocomplete',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.placeholder,"fetch-suggestions":_vm.querySearch,"size":"small","trigger-on-focus":false,"validate-event":false},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }